export class EventEmitterTicketsBo
{
    isEntry: boolean = false;  
    tickets :TicketsBO = new TicketsBO() ;
    isEdit : boolean = false;
    
}

export class GetTicketsBO {
    id : string;
    pageitem: number= 250;
    currentpageno: number=1;
    field: string = "uniqueTicketId";
    value: string = "";
    orderColumn: string = "createdTime";
    orderType: string = "desc";
    matchCase: boolean = false;
    operator: string = "contains";
    type: string = "string";
    employeeId: string;
    priorityLid: string;
    statusLid: string;
    ticketTypeLid:string;
    engagementLogsId: string;
    clientId : string;

}

export class CommentBO {
    id: number;
    userName: string;
    userInitials: string;
    timestamp: Date;
    text: string;
    edited: boolean;
  }
export class TicketsBO {
    id: string;
    title: string;
    description: string;
    ticketStatusLid: string;
    priorityLid: string;
    ticketTypeLid: string;
    createDate: string;
    modifiedDate: string | null;
    ticketAttachments: TicketAttachmentsBO[] =[];
    tags: number[]=[];
    statusLid: string;
    employeeId: string;
    summary:string;
    uniqueTicketId : string;
    clientId : string;
    
}

export class TicketAttachmentsBO {
    id: number;
    fileName: string;
    filePath: string;
    ticketId: number;
    fileString: string;
}

export class TagsBO {
   
    taglovId: number;
}
export class CommentsBO {
    id: number;
    ticketId: number;
    authorId: number;
    commentText: string;
    parentCommentId: number | null;
    usersId: number[];
}

export class User {
    initials: string;
    name: string;
    color?: string;
  }


  
export class GetEngementBO {
   
    pageitem: number= 10;
    currentpageno: number=1;
    agencyId: number;
    employee:number=0;
    client:number=0;
    field: string = "CustomerName";
    value: string = "";
    orderColumn: string = "CustomerName";
    orderType: string = "ASC";
    matchCase: boolean = false;
    operator: string = "startswith";
    type: string = "string";
    requesttype: string = "getdata"
    ticketId:string

 
}

export class LinkEngagement{
    ticketId : string;
    engagementLogsIds : string[];
  }
  export class LinkInbox{
    ticketId : string;
    engagementLogsIds : string[];
  }

  export class functionpermission{
    ticketcreate:boolean = true;
    ticketupdate:boolean = true;
    ticketdelete:boolean = true;
    linkengagement:boolean = true;
    linkinbox : boolean = true; 

  }